var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.13 24.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.19,0c2.34,0,5.57.38,6.78.7.26.06.48.22.48.58v3.23c0,.29-.13.54-.54.54h-.06c-.9-.06-4.61-.35-6.78-.35-1.82,0-2.5.54-2.5,1.7,0,.9.42,1.31,2.14,2.24l4.1,2.21c3.33,1.79,4.32,3.9,4.32,6.5,0,3.39-2.24,7.01-8.74,7.01-2.53,0-4.42-.29-6.05-.7-.32-.1-.64-.29-.64-.64v-3.14c0-.45.26-.61.58-.61h.1c1.31.13,4.83.38,6.08.38,2.21,0,2.85-.7,2.85-2.24,0-.93-.45-1.44-2.11-2.43l-4.42-2.62C.8,10.59,0,8.58,0,6.24,0,2.72,1.98,0,8.19,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS);
export default __webpack_public_path__ + "static/media/S.5d1f21f5f45804cd52ce98ba210611d8.svg";
export { ForwardRef as ReactComponent };